import React from 'react';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  tableCell: {
    border: '2px solid #ffffff'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    dataConfirm,
    title,
    openAddProgress,
    progressOkAction,
    loading,
    resultMessage,
    otherData
  }) => {
    return (
      <div className={classes.root}>
        <Typography variant="h6">{title}</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                イベント名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.gochiEventName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                イベント種別
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.eventCategory === 2
                  ? 'イベントメニューの対象'
                  : '全グループの対象'}
              </TableCell>
            </TableRow>
            {dataConfirm.eventCategory === 1 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  対象グループ
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {otherData.groupName}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>公開時間</TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.startDate &&
                  moment(dataConfirm.startDate).format('YYYY-MM-DD HH:mm:ss')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>終了時間</TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.endDate &&
                  moment(dataConfirm.endDate).format('YYYY-MM-DD HH:mm:ss')}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                手数料負担率
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.eventFeeRate}
              </TableCell>
            </TableRow>
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  プレミアム分
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.supportPricePercentRate}
                </TableCell>
              </TableRow>
            )}
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  拠出予算額
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.maxTotalAmount}
                </TableCell>
              </TableRow>
            )}
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  一回あたりの購入上限額
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.maxTotalAmountPerOrder}
                </TableCell>
              </TableRow>
            )}
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  1店舗あたりの購入上限額
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.maxTotalAmountShop}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                店舗が負担する手数料率
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {dataConfirm.shopFeeRate}
              </TableCell>
            </TableRow>
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用開始日
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.gochiStartDate &&
                    moment(dataConfirm.gochiStartDate).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )}
                </TableCell>
              </TableRow>
            )}
            {dataConfirm.eventCategory === 2 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用期限
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {dataConfirm.gochiExpriedDate &&
                    moment(dataConfirm.gochiExpriedDate).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )}
                </TableCell>
              </TableRow>
            )}
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
        <ProgressDialog
          openProgress={openAddProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
